module.exports = __webpack_public_path__ + "img/sandrine_square.0c95be65.jpg";